import { render, staticRenderFns } from "./MixerLoadsItemMobile.vue?vue&type=template&id=0363d99b&lang=pug&"
import script from "./MixerLoadsItemMobile.vue?vue&type=script&lang=js&"
export * from "./MixerLoadsItemMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports